import axios from "axios";
import { attachMockInterceptor } from "./setupMockInterceptors";
import {
  getAffiliatePortalToken,
  clearAffiliatePortalAndRedirect,
} from "../utils/tokenUtils";

/**
 * Axios instance for the affiliate portal.
 *
 * Two things that differ from the staff `PrivateAdminPanelInstance`:
 *   1. We send the AccessToken (not the IdToken). The BE binds
 *      the affiliate identity to the `custom:affiliate_id` claim, which is
 *      only present on the AccessToken.
 *   2. There is no refresh flow in this slice — `/me` is a handshake to prove
 *      the auth wiring works end-to-end. A 401 kicks the user back to the
 *      portal sign-in; the refresh story is a follow-up.
 */
const createAffiliatePortalInstance = () => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_ADMIN_PANEL_BACKEND_BASE_URL,
  });

  instance.interceptors.request.use(
    (config) => {
      const token = getAffiliatePortalToken();
      if (token?.AccessToken) {
        config.headers.Authorization = `Bearer ${token.AccessToken}`;
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  attachMockInterceptor(instance);

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        clearAffiliatePortalAndRedirect();
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

export default createAffiliatePortalInstance;
